import React, { useState, useRef, useEffect } from 'react';

interface IProps {
  [key: string]: any;
}

const useSetState = (initialState: IProps = {}) => {
  const [state, setState] = useState(initialState);

  const isMounted = useRef(false);

  useEffect(() => {
    //
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return {
    state,
    setState: $ => {
      if (isMounted.current) {
        return setState({
          ...state,
          ...(typeof $ === 'function' ? $(state) : $),
        });
      }
    },
  };
};

export default useSetState;
